import React from 'react';

import { DealStateEnum } from '../../../../utils/types/deal';
import { DealWithFarthestState } from '../../utils';
import SignButtons from '../SignButtons';

const getCurrentStepActions = (
  deal: DealWithFarthestState,
): { description?: React.ReactNode; cta?: React.ReactNode } | undefined => {
  const state = deal.state as DealStateEnum;
  if (state === DealStateEnum.Closed) {
    return {
      description: "Sit tight, we're getting your documents ready for signing.",
      cta: <SignButtons deal={deal} buttonProps={{ size: 'sm' }} alignItems="flex-start" />,
    };
  }
  if (state === DealStateEnum.SentForSignatures) {
    return {
      description: "Congratulations! You're ready to sign your documents!",
      cta: <SignButtons deal={deal} buttonProps={{ size: 'sm' }} alignItems="flex-start" />,
    };
  }
  return undefined;
};

export default getCurrentStepActions;
